import { render, staticRenderFns } from "./misIndicadores.vue?vue&type=template&id=4bbbae97"
import script from "./misIndicadores.vue?vue&type=script&lang=js"
export * from "./misIndicadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports